// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a6b78227","667":"e7a536f9","977":"ccdf65a9"}[chunkId] + ".chunk.js";
};